<li #item class="item">
    <div class="item__header" [class.item__header--active]="isActive">
        <a routerLink="." [fragment]="data.id" class="item__header__anchor">
            <span [innerHtml]="data.name"></span>
        </a>
    </div>
</li>
